import { Attachment, AttachmentContent, AttachmentMedia, AttachmentTitle, AttachmentTrigger } from '@/components/ui/attachment';
import { AudioLinesIcon, FileIcon, FileTextIcon, FilmIcon, ImageIcon } from '@/shared/icon-library';

const FILE_ICON_CLASS = 'size-4 shrink-0 text-foreground-muted';

export function FileTypeIcon({ mime }: { mime: string }) {
  if (mime.startsWith('image/')) {
    return <ImageIcon className={FILE_ICON_CLASS} aria-hidden />;
  }
  if (mime.startsWith('video/')) {
    return <FilmIcon className={FILE_ICON_CLASS} aria-hidden />;
  }
  if (mime.startsWith('audio/')) {
    return <AudioLinesIcon className={FILE_ICON_CLASS} aria-hidden />;
  }
  if (mime.startsWith('text/') || mime === 'application/pdf') {
    return <FileTextIcon className={FILE_ICON_CLASS} aria-hidden />;
  }
  return <FileIcon className={FILE_ICON_CLASS} aria-hidden />;
}

interface FileCardProps {
  name: string;
  mime: string;
  href?: string;
  onOpen?: () => void;
}

export function FileCard({ name, mime, href, onOpen }: FileCardProps) {
  return (
    <Attachment size="xs" data-file-block="" onClick={href ? undefined : onOpen} className="my-0.5">
      <AttachmentMedia>
        <FileTypeIcon mime={mime} />
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle>{name}</AttachmentTitle>
      </AttachmentContent>
      {href ? (
        <AttachmentTrigger asChild>
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={name} />
        </AttachmentTrigger>
      ) : onOpen ? (
        <AttachmentTrigger aria-label={name} className="cursor-pointer" />
      ) : null}
    </Attachment>
  );
}
